import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-dropdown-check",
  "use": "icon-dropdown-check-usage",
  "viewBox": "0 0 12 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 14\" id=\"icon-dropdown-check\">\n    <g stroke=\"currentColor\" stroke-width=\"2\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"square\">\n        <path d=\"M5.5 8.5L10 4M4.5 9.5L2 7\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol